angular.module('impactx.search').controller('LotItemCtrl', [
    '$redirect',
    'AppConfiguration',
    'panelService',
    '$routeParams',
    'SearchFilterStorage',
    LotItemController
]);

function LotItemController($redirect, AppConfiguration, panelService, $routeParams, SearchFilterStorage) {
    var self = this;

    self.redirectToDetails = function () {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.lotId = {value: self.lot.id};
            filter.dialogFilter = "lot";
            SearchFilterStorage.setLotFilter(self.lot.id, filter);
        }
        $redirect.redirectTo(null, "lot/" + self.lot.id + (($routeParams.useSetFilter || $routeParams.useSetFilterList) ? "/true" : ""));
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.getLotPanelColor = panelService.getLotPanelColor;
}